var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1137_2097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32Z",
    fill: "#D3F4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.31 18.1591C31.2983 18.1224 31.2867 18.0841 31.2733 18.0474C31.18 17.7707 31.0733 17.4907 30.95 17.2157C30.5533 16.3241 29.995 15.4791 29.2483 14.9141C29.2483 14.9141 27.7 13.4091 25.85 13.1074C25.85 13.1074 22.13 12.6557 21.5067 12.9357C21.2633 13.0441 21.335 16.3774 22.2383 17.6674C22.2383 17.6674 23.5283 20.7641 27.27 21.4524C27.27 21.4524 28.8983 21.8007 30.9417 21.7257C31.0617 21.5007 31.8533 19.9257 31.31 18.1607V18.1591Z",
    fill: "#6ABD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3733 21.7424C31.3533 21.7424 31.3333 21.7424 31.3133 21.7424C31.33 21.7474 31.35 21.7491 31.3733 21.7424Z",
    fill: "#6ABD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.27 21.7107C31.16 21.7174 31.05 21.7224 30.9417 21.7257C30.935 21.7374 30.9317 21.7457 30.9283 21.7491H31.1083C31.165 21.7491 31.235 21.7457 31.315 21.7441C31.2867 21.7341 31.27 21.7107 31.27 21.7107Z",
    fill: "#6ABD45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.13 13.1074C39.275 12.4907 35.915 13.1074 35.915 13.1074C32.3583 13.8974 31.1267 16.7557 30.95 17.2157C31.0733 17.4907 31.18 17.7707 31.2733 18.0474C31.2867 18.0841 31.2983 18.1224 31.31 18.1591C31.8533 19.9257 31.0617 21.5007 30.9417 21.7241C31.05 21.7207 31.16 21.7157 31.27 21.7091C31.27 21.7091 31.285 21.7324 31.315 21.7424C31.335 21.7424 31.7233 21.7474 31.7433 21.7474C32.6917 21.7224 34.495 21.6541 35.055 21.5791C39.1417 21.0407 40.0867 16.8474 40.0867 16.8474C40.41 14.4391 40.13 13.1057 40.13 13.1057V13.1074Z",
    fill: "#549E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3383 24.4474H33.2567C33.0667 24.0224 32.4717 22.6207 32.4533 21.7307H31.1083C30.9933 21.7341 30.925 21.7357 30.925 21.7357C30.925 21.7357 30.925 21.7341 30.9267 21.7307H30.1933C30.1933 21.7307 29.7767 23.8374 29.3417 24.4474H27.6433C22.51 24.4474 18.3333 28.6257 18.3333 33.7591V41.8157C18.3333 46.9507 22.51 51.1274 27.645 51.1274H36.3383C41.4733 51.1274 45.65 46.9507 45.65 41.8157V33.7591C45.65 28.6241 41.4733 24.4474 36.3383 24.4474ZM41.65 41.8424C41.65 44.7641 39.2817 47.1341 36.3583 47.1341H27.615C24.6933 47.1341 22.3233 44.7657 22.3233 41.8424V33.7707C22.3233 30.8491 24.6917 28.4791 27.615 28.4791H36.3583C39.28 28.4791 41.65 30.8474 41.65 33.7707V41.8424Z",
    fill: "#16351D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1083 21.7307H30.9283L30.9267 21.7357C30.9267 21.7357 30.995 21.7357 31.11 21.7307H31.1083Z",
    fill: "#16351D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.68 34.5524H27.785C27.5245 34.5524 27.3133 34.7636 27.3133 35.0241V40.7474C27.3133 41.0079 27.5245 41.2191 27.785 41.2191H29.68C29.9405 41.2191 30.1517 41.0079 30.1517 40.7474V35.0241C30.1517 34.7636 29.9405 34.5524 29.68 34.5524Z",
    fill: "#16351D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1733 34.5524H34.2783C34.0178 34.5524 33.8067 34.7636 33.8067 35.0241V40.7474C33.8067 41.0079 34.0178 41.2191 34.2783 41.2191H36.1733C36.4338 41.2191 36.645 41.0079 36.645 40.7474V35.0241C36.645 34.7636 36.4338 34.5524 36.1733 34.5524Z",
    fill: "#16351D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1137_2097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlant);
export default __webpack_public_path__ + "static/media/LogoPlant.aa7c560f48f2f097b7b450ba012c6970.svg";
export { ForwardRef as ReactComponent };